import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Icon } from "@syarahtech/ui";
import AddToFavoriteButton from "@/common/HOCs/AddToFavorite/AddToFavoriteButton";
import ShareNP from "@/pages/post/components/leftColumn/components/shareNP/ShareNP";
/** Figma 4121:23862 — 25px outlined circle, ~14px glyph. */
var circleClass = "inline-flex size-[25px] shrink-0 cursor-pointer items-center justify-center rounded-full border border-solid border-[#e6e9ef] bg-white p-0 text-navy-primary";

/**
 * Favorite + share for the responsive car-details header.
 *
 * Portalled into the `#mobile-header-actions` slot that `MobileHeader` renders,
 * rather than reimplemented: `AddToFavoriteButton` owns the favourite state,
 * auth popup, notification-interest modal and tracking, and `ShareNP` owns the
 * share sheet and its events. Only the triggers are restyled here — via
 * `renderFunction` and `renderTrigger` respectively.
 *
 * Renders nothing until the slot exists, so it is inert on any page whose
 * header has no actions area.
 */
var PostViewMobileHeaderActions = function PostViewMobileHeaderActions(_ref) {
  var postId = _ref.postId,
    g4_data = _ref.g4_data,
    shareLink = _ref.shareLink,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? null : _ref$fallback;
  // `undefined` = not looked yet (first paint), `null` = looked and absent.
  var _useState = useState(undefined),
    slot = _useState[0],
    setSlot = _useState[1];
  useEffect(function () {
    setSlot(document.getElementById("mobile-header-actions"));
  }, []);
  if (slot === undefined) return null;
  if (!slot) return /*#__PURE__*/React.createElement(React.Fragment, null, fallback);
  return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ShareNP, {
    postDynamicLink: shareLink,
    renderTrigger: function renderTrigger(open) {
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        id: "pdp-share",
        "data-id": "pdp-share",
        onClick: open,
        className: circleClass
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "material-symbols--ios-share-rounded",
        width: 3.5,
        height: 3.5
      }));
    }
  }), /*#__PURE__*/React.createElement(AddToFavoriteButton, {
    postId: postId,
    g4_data: g4_data,
    className: "",
    renderFunction: function renderFunction(favClickHandler, isFavorite) {
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        id: "pdp-favorite",
        "data-id": "pdp-favorite",
        onClick: favClickHandler,
        className: circleClass
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: isFavorite ? "material-symbols--favorite-rounded" : "material-symbols--favorite-outline-rounded",
        width: 3.5,
        height: 3.5,
        className: isFavorite ? "text-primary" : undefined
      }));
    }
  })), slot);
};
export default PostViewMobileHeaderActions;